/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Use_Password_InsteadInputs */

const fr_auth_use_password_instead = /** @type {(inputs: Auth_Use_Password_InsteadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter plutôt avec un email et un mot de passe`)
};

const en_auth_use_password_instead = /** @type {(inputs: Auth_Use_Password_InsteadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with an email and password instead`)
};

/**
* | output |
* | --- |
* | "Sign in with an email and password instead" |
*
* @param {Auth_Use_Password_InsteadInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_use_password_instead = /** @type {((inputs?: Auth_Use_Password_InsteadInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Use_Password_InsteadInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_use_password_instead(inputs)
	return fr_auth_use_password_instead(inputs)
});